import React, { useState, useEffect } from "react";
import {
    Space,
    Dropdown,
} from "antd";
import { toPrice } from "../../../helpers/stringFormat";
import "../../../style/sample.css";
import { backendPostWithoutRefresh } from "../../../helpers/callBackend";
import TransactionTableFilters from "./transactionTableFilters";
import GenericTableOnRowOnClick1 from "../../tables/genericTableOnRowOnClick1";
import HideOnMobile from "../../generic/hideOnMobile";
import moment from "moment";
import TransactionsDrawerSimple from "./transactionsDrawerSimple";
import { MoreVert } from "@mui/icons-material";

const ScheduledTransactions = (props) => {
    const [showTxns, setShowTxns] = useState(props.transactions);
    const [selectedTransactionData, setSelectedTransactionData] = useState(null);
    const [dateRangeFilter, setDateRangeFilter] = useState(null);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    useEffect(() => {
        setShowTxns(props.transactions)
    }, [props.transactions]);

    const handleExpand = (expanded, record) => {
        if (expanded) {
            setExpandedRowKeys([record.id]);
            setSelectedTransactionData({
                "CREATED AT": moment(record.attributes.createdAt).format("MMMM Do, YYYY"),
                "SCHEDULED FOR": record.attributes.schedule.nextScheduledAction,
                "NO. OF PAYMENTS": record.attributes.numberOfPayments,
                "PAYMENT FREQUENCY": record.attributes.schedule.interval,
            });
        } else {
            setExpandedRowKeys([]);
        }
    };

    const cancelTxn = (record) => {
        var data = {
            unit_payment_id: record.id,
            is_recurring: true,
        };
        backendPostWithoutRefresh("/api/transactions/cancel-transaction/", data)
            .then((response) => {
                if (response.data.description === "Transaction canceled") {
                    props.cancelScheduledTransaction(record.id, () => {
                        setShowTxns(props.transactions);
                    });
                }
            })
    }

    const handleSearch = (e) => {
        if (e.target.value === "") {
            setShowTxns(props.transactions);
        } else {
            let search_text = e.target.value;
            var data = props.transactions;
            var resData = [];
            for (var i = 0; i < data.length; i++) {
                var prop_name1 = data[i]["attributes"]["description"];
                var prop_name2 = data[i]["attributes"]["createdAt"];
                var prop_name3 = data[i]["type"];

                if (
                    prop_name1.toLowerCase().indexOf(search_text.toLowerCase()) > -1 ||
                    prop_name2.toLowerCase().indexOf(search_text.toLowerCase()) > -1 ||
                    prop_name3.toLowerCase().indexOf(search_text.toLowerCase()) > -1
                ) {
                    resData.push(data[i]);
                }
            }
            setShowTxns(resData);
        }
    };

    const handleDateFilter = (value) => {
        if (value && value.length === 2) {
            var start_date = value[0].format("YYYY-MM-DD");
            var end_date = value[1].format("YYYY-MM-DD");

            var data = props.transactions;
            var resData = [];
            for (var i = 0; i < data.length; i++) {
                var txn_date = data[i]["attributes"]['createdAt'].split("T")[0];
                if (txn_date >= start_date && txn_date <= end_date) {
                    resData.push(data[i]);
                }
            }
            setDateRangeFilter(value);
            setShowTxns(resData);
        }
        else {
            setShowTxns(props.transactions);
        }
    };

    const table_columns = [
        {
            field: 'nextScheduledAction',
            headerName: 'Scheduled For',
            flex: 1,
            sortable: true,
            sortComparator: (v1, v2) =>
                new Date(v1?.attributes?.schedule?.nextScheduledAction).getTime() -
                new Date(v2?.attributes?.schedule?.nextScheduledAction).getTime(),
            renderCell: (params) => (
                <span>
                    {params?.row?.attributes?.schedule?.nextScheduledAction?.slice(0, 10)}
                    <span style={{ fontStyle: 'italic', color: 'grey', fontSize: '12px', paddingLeft: '10px' }}>
                        {moment(params?.row?.attributes?.schedule?.nextScheduledAction).format('h:mm A')}
                    </span>
                </span>
            ),
        },
        {
            field: 'counterpartyName', // Use a descriptive name for the field
            headerName: 'To/From',
            flex: 1,
            valueGetter: (params) => {
                // Determine the value based on the condition
                return params?.row?.type?.startsWith("Originated")
                    ? params?.row?.attributes?.counterparty?.name || ''
                    : params?.row?.relationships?.counterparty?.data?.name || '';
            },
            renderCell: (params) => (
                <p style={{ textTransform: 'capitalize' }}>
                    {params?.row?.type?.startsWith("Originated")
                        ? params?.row?.attributes?.counterparty?.name
                        : params?.row?.relationships?.counterparty?.data?.name}
                </p>
            ),
        },
        {
            field: 'description',
            headerName: 'Description',
            flex: 2,
            renderCell: (params) => (
                <p style={{ textTransform: 'capitalize' }}>
                    {params?.row?.attributes?.description}
                </p>
            ),
        },
        {
            field: 'method',
            headerName: 'Method',
            flex: 1,
            renderCell: (params) => (
                <p style={{ textTransform: 'capitalize' }}>
                    {params?.row?.type}
                </p>
            ),
        },
        {
            field: 'amount',
            headerName: 'Amount',
            flex: 1,
            renderCell: (params) => (
                <span>
                    {toPrice(params?.row?.attributes?.amount)}
                </span>
            ),
        },
        {
            field: 'action',
            headerName: '',
            flex: 0.5,
            align: 'right',
            renderCell: (params) => (
                <HideOnMobile>
                    <Dropdown
                        overlay={
                            <div style={{ backgroundColor: 'white', padding: '10px' }}>
                                <div
                                    style={{
                                        border: '0px',
                                        color: 'red',
                                        backgroundColor: 'transparent',
                                        cursor: 'pointer',
                                    }}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        cancelTxn(params.row);
                                    }}
                                >
                                    Cancel
                                </div>
                            </div>
                        }
                        placement="bottomLeft"
                        arrow
                    >
                        <MoreVert fontSize="inherit" />
                    </Dropdown>
                </HideOnMobile>
            ),
        },
    ];


    // const table_columns = [
    //     {
    //         title: "Scheduled For",
    //         dataIndex: "timestamp",
    //         width: "15%",
    //         render: (text, record) => <span>{record.attributes?.schedule?.nextScheduledAction}</span>,
    //         defaultSortOrder: "descend",
    //         sorter: (a, b) => a.attributes?.schedule?.nextScheduledAction?.localeCompare(b.attributes.schedule.nextScheduledAction),
    //     },
    //     {
    //         'title': 'To/From',
    //         'width': '15%',
    //         'render': (_, record) => (
    //             record.type.startsWith("Originated") ? (
    //                 <p style={{ textTransform: 'capitalize' }}>
    //                     {record.attributes?.counterparty?.name}
    //                 </p>
    //             ) : (
    //                 <p style={{ textTransform: 'capitalize' }}>
    //                     {record.relationships?.counterparty?.data.name}
    //                 </p>
    //             )
    //         )
    //     },
    //     {
    //         title: "Description",
    //         width: "40%",
    //         render: (_, record) => (
    //             <p style={{ textTransform: "capitalize" }}>
    //                 {record.attributes?.description}
    //             </p>
    //         ),
    //     },
    //     {
    //         title: "Method",
    //         width: "15%",
    //         render: (_, record) => (
    //             <p style={{ textTransform: "capitalize" }}>
    //                 {record.type}
    //             </p>
    //         ),
    //     },
    //     {
    //         title: "Amount",
    //         width: "10%",
    //         align: "right",
    //         render: (_, record) => (
    //             <span style={{ color: "" }}>
    //                 {toPrice(record.attributes?.amount)}
    //             </span>
    //         ),
    //     },
    //     {
    //         title: "",
    //         width: "5%",
    //         dataIndex: "action",
    //         render: (text, record) => (
    //             <HideOnMobile>
    //                 <Dropdown
    //                     overlay={
    //                         <div style={{ backgroundColor: "white", padding: "10px" }}>
    //                             <div
    //                                 style={{
    //                                     border: "0px",
    //                                     color: "red",
    //                                     backgroundColor: "transparent",
    //                                     cursor: "pointer",
    //                                 }}
    //                                 onClick={(event) => {
    //                                     event.stopPropagation();
    //                                     cancelTxn(record);
    //                                 }}
    //                             >
    //                                 Cancel
    //                             </div>
    //                         </div>
    //                     }
    //                     placement="bottomLeft"
    //                     arrow
    //                 >
    //                     <MoreOutlined style={{ fontSize: "20px" }} />
    //                 </Dropdown>
    //             </HideOnMobile>
    //         ),
    //     },
    // ];

    const totalTableWidth = table_columns.reduce((totalWidth, column) => {
        return totalWidth + parseFloat(column.width || 0);
    }, 0);

    const firstColumnWidthFraction = parseFloat(table_columns[0].width || 0) / totalTableWidth;
    const expandableOffset = Math.ceil(firstColumnWidthFraction * 100);

    const expandableConfig = {
        expandedRowRender: (record) =>
            <TransactionsDrawerSimple
                selectedTransactionData={selectedTransactionData}
                offset={expandableOffset}
            />,
        expandRowByClick: true,
        onExpand: handleExpand,
        expandedRowKeys: expandedRowKeys,
        expandIconColumnIndex: -1,
    };

    const exportData = () => {
        let exportdata = [];
        for (var i = 0; i < showTxns.length; i++) {
            var item = showTxns[i];
            var data = {
                Date: item.attributes.schedule.nextScheduledAction,
                Description: item.attributes.description,
                Method: item.type,
                "To/From": item.counterparty_name,
                Amount:
                    item.attributes.amount >= 0
                        ? `$${parseFloat(item.attributes.amount).toFixed(2)}`
                        : `- $${parseFloat(
                            Math.abs(item.attributes.amount)
                        ).toFixed(2)}`,
            };
            exportdata.push(data);
        }
        return exportdata;
    }

    const TransactionDrawerX = () => (
        <TransactionsDrawerSimple
            selectedTransactionData={selectedTransactionData}
            offset={expandableOffset}
        />
    )
    return (
        <Space direction="vertical" style={{ width: "100%" }}>
            <TransactionTableFilters
                handleSearch={handleSearch}
                handleDateFilter={handleDateFilter}
                dateRangeFilter={dateRangeFilter}
                bankAccountName={props.bankAccountName}
                exportdata={exportData()}
            />
            <GenericTableOnRowOnClick1
                pagination={{
                    paginationModel: { pageSize: showTxns?.length || 10, page: 0 },
                }}
                pageSizeOptions={[5, 10, 25]}
                sortModel={[
                    {
                        field: "nextScheduledAction",
                        sort: "desc",
                    },
                ]}
                columns={table_columns}
                dataSource={showTxns}
                enableExpandable={true}
                numerator={props.numerator}
                denominator={props.denominator}
                handleExpand={handleExpand}
                transactionDrawerComponent={TransactionDrawerX}
                loading={props.loadingIncompleteTransactions}
            />
            {/* <GenericTableOnRowOnClick
                pagination={{
                    className: "card-table-pagination",
                    defaultPageSize: 50,
                    showSizeChanger: true,
                }}
                columns={table_columns}
                dataSource={showTxns}
                expandableConfig={expandableConfig}
                loading={props.loadingIncompleteTransactions}
            /> */}
        </Space>
    );
}

export default ScheduledTransactions;
